module.exports = __webpack_public_path__ + "img/1517044055.f4365ea4.jpg";